import React from 'react';
import PropTypes from 'prop-types';
import loader from 'assets/loader.svg';
import './index.scss';

const Loader = (props) => {
  const { isLoading, spinnerPageCenter, children } = props;

  const loaderClassName = `loader loading-indicator ${
    spinnerPageCenter ? 'spinner-page-center' : ''
  }`;

  return (
    <div className="loader-bg">
      {isLoading && (
        <div className={loaderClassName}>
          <img className="gecko-spinner" src={loader} alt="Loading Spinner" />
          <p>Loading...</p>
        </div>
      )}
      <div className={isLoading && 'blur'}>{children}</div>
    </div>
  );
};

Loader.defaultProps = {
  isLoading: false,
  spinnerPageCenter: false,
  children: null,
};

Loader.propTypes = {
  isLoading: PropTypes.bool,
  spinnerPageCenter: PropTypes.bool,
  children: PropTypes.node,
};

export default Loader;
